import { LmsProfileTypes } from 'enum/lms-profile-types.enum'
import { IBasicProfile } from 'models/lmsProfile.model'
import api from '../..'

// Trae id y nombre de todos los perfiles lms
const getProfilesList = (ransack?: { profile_type_eq?: LmsProfileTypes }) => {
  return api
    .get<IBasicProfile[]>(`/administration/lms_profiles/list`, {
      params: {
        ransack,
      },
    })
    .then(({ data }) => data)
}

export default getProfilesList
